export const routes = [
  {
    path: '/',
    redirect: '/home',
    meta: { hideInMenu: true }
  },
  {
    path: '/home',
    name: 'home',
    meta: { title: '首页' },
    component: () => import(/* webpackChunkName: "home" */ '@/views/home')
  },
  {
    path: '/core',
    name: 'core',
    meta: { title: '核心技术' },
    component: () => import(/* webpackChunkName: "core" */ '@/views/core')
  },
  {
    path: '/product',
    name: 'product',
    redirect: '/product/dmp',
    meta: { title: '产品中心' },
    component: () => import(/* webpackChunkName: "product" */ '@/views/product'),
    children: [
      {
        path: 'dmp',
        meta: { title: '“三峡”海量计算引擎', icon: require('@/assets/menu-sx.png'), detail: '应对企业多品牌、多系统、多权限的复杂业务场景' },
        component: () => import(/* webpackChunkName: "product" */ '@/views/product/dmp'),
      },
      {
        path: 'qd',
        meta: { title: '“去电”数智化用户经营平台', icon: require('@/assets/menu-qd.png'), detail: '体验真实、千人千面的用户经营策略，低成本' },
        component: () => import(/* webpackChunkName: "product" */ '@/views/product/qd'),
      },
      {
        path: 'AICallbot',
        meta: { title: '“去电”反诈劝阻机器人', icon: require('@/assets/menu-fz.png'), detail: '提高反诈劝阻的及时性、有效性及劝阻成功率' },
        component: () => import(/* webpackChunkName: "product" */ '@/views/product/aiCallbot'),
      },
      {
        path: 'enterprise-call',
        meta: { title: '智能企业电话', icon: require('@/assets/icon-call.png'), detail: '突破手机限制的智能电话，一键跟进意向客户，精准流量直接变现' },
        component: () => import(/* webpackChunkName: "product" */ '@/views/product/enterpriseCall'),
      },
      {
        path: 'voice-push',
        meta: { title: '科应™来电卫士', icon: require('@/assets/icon-sdk.png'), detail: '一款轻灵小巧的随身助手，帮您接待来话，亲切沟通' },
        component: () => import(/* webpackChunkName: "product" */ '@/views/product/voiceSdk'),
      },
    ]
  },
  {
    path: '/apply',
    name: 'apply',
    meta: { title: '解决方案' },
    component: () => import(/* webpackChunkName: "apply" */ '@/views/apply')
  },
  {
    path: '/customer',
    name: 'customer',
    meta: { title: '运营体系' },
    component: () => import(/* webpackChunkName: "customer" */ '@/views/customer')
  },
  // {
  //   path: '/hotdata',
  //   name: 'hotdata',
  //   meta: { title: '热点数据', href: 'https://datav.aliyun.com/share/05edfeb78fbacbf5ba96b05e6ecd42e9' },
  //   component: () => import(/* webpackChunkName: "hot" */ '@/views/hotdata')
  // },
  {
    path: '/about',
    name: 'about',
    redirect: '/about/callai',
    meta: { title: '关于我们' },
    component: () => import(/* webpackChunkName: "about" */ '@/views/about/index.vue'),
    children: [
      {
        path: 'callai',
        name: 'callai',
        meta: { title: '关于去电', icon: '', detail: '去电人工智能，由一支持续创业多年的互联网团队发起于2016年底...' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/about/callai.vue'),
      },
      // {
      //   path: 'news',
      //   name: 'news',
      //   meta: { title: '最新动态', icon: '', detail: '万蚓网络科技(上海)有限公司『去电人工智能』，由一支持续创业多年的资深互联网团队' },
      //   component: () => import(/* webpackChunkName: "about" */ '@/views/about/news.vue'),
      // },
      {
        path: 'joinus',
        name: 'joinus',
        meta: { title: '加入我们', icon: '', detail: '你是一只雄鹰，不要安于雀笼，我在去电，等你来...', href: 'https://www.zhipin.com/gongsi/0f363f9708d91cc61nJ42N29Eg~~.html' },
        component: () => import(/* webpackChunkName: "about" */ '@/views/about/joinus.vue'),
      },
      // {
      //   path: 'news/:newsId',
      //   name: 'newsDetail',
      //   meta: { hideInMenu: true },
      //   component: () => import(/* webpackChunkName: "about" */ '@/views/about/news-detail.vue')
      // }
    ]
  },
]

export const menuList = routes.filter(v => {
  return !v.meta.hideInMenu
})
